import React, { useState, useEffect } from "react";
import { Phone, Menu as MenuIcon, X } from "lucide-react";
import { restaurantInfo } from "../data/mock";
import { useLanguage } from "../context/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Header({ onReserve }) {
  const { t } = useLanguage();
  const LINKS = [
    { id: "home", label: t.nav.home },
    { id: "about", label: t.nav.about },
    { id: "menu", label: t.nav.menu },
    { id: "gallery", label: t.nav.gallery },
    { id: "sponsor", label: t.nav.sponsor },
    { id: "contact", label: t.nav.contact },
  ];

  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("home");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
      for (const l of LINKS) {
        const el = document.getElementById(l.id);
        if (el) {
          const r = el.getBoundingClientRect();
          if (r.top <= 120 && r.bottom >= 120) {
            setActive(l.id);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // eslint-disable-next-line
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#1B1512]/95 backdrop-blur-md py-2 shadow-lg" : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button onClick={() => scrollTo("home")} className="flex items-center gap-3 group">
          <img
            src="/images/logo_new.png"
            alt="Puri Puri Flensburg – Indisches Restaurant"
            className={`transition-all duration-500 object-contain ${scrolled ? "h-12" : "h-16"}`}
          />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <span
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className={`nav-link ${active === l.id ? "active text-[#E9C97A]" : ""}`}
            >
              {l.label}
            </span>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <LanguageSwitcher variant="header" />
          <a href={`tel:${restaurantInfo.phoneClean}`} className="btn-outline" style={{padding: "0.55rem 1.1rem"}}>
            <Phone size={16} />
            {restaurantInfo.phone}
          </a>
          <button onClick={onReserve} className="btn-primary" style={{padding: "0.55rem 1.1rem"}}>
            {t.nav.reserve}
          </button>
        </div>

        <div className="lg:hidden flex items-center gap-2">
          <LanguageSwitcher variant="header" />
          <button className="text-[#FBEFD9]" onClick={() => setOpen((v) => !v)} aria-label="menu">
            {open ? <X size={28} /> : <MenuIcon size={28} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#1B1512]/98 backdrop-blur-md border-t border-[#D4A94A]/20">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {LINKS.map((l) => (
              <span key={l.id} onClick={() => scrollTo(l.id)} className="nav-link text-lg">
                {l.label}
              </span>
            ))}
            <div className="flex flex-col gap-2 pt-3">
              <a href={`tel:${restaurantInfo.phoneClean}`} className="btn-outline w-full justify-center">
                <Phone size={16} /> {restaurantInfo.phone}
              </a>
              <button onClick={() => { setOpen(false); onReserve(); }} className="btn-primary w-full justify-center">
                {t.nav.reserve}
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
